<template>
    <form class="cl-form">
        <slot></slot>
    </form>
</template>

<script>
    export default {
        name: "clForm",
        props: {
            modal: Object,
            rules: Object
        },
        provide() {
            return {
                clForm: this
            }
        },
        data() {
            return {
                fields: []
            }
        },
        created() {
            this.$on('cl.form.addField', (field) => {
                if (field) {
                    this.fields.push(field);
                }
            });
            this.$on('cl.form.removeField', (field) => {
                if (field.prop) {
                    this.fields.splice(this.fields.indexOf(field), 1);
                }
            });
        },
        methods: {
            validate() {
                let fields = this.fields;
                let flag = true;
                for(let i = 0, l = fields.length; i < l; i++) {
                    let field = fields[i];
                    flag = field.checkProp();
                }
                return flag;
            }
        }
    }
</script>

<style scoped lang="less">
    .cl-form {
        padding: 40px;
    }
</style>
